import React, { Component } from 'react';
// import { Redirect } from "react-router-dom";
import Drivers from './Drivers';
import SearchBar from './SearchBar';
import CurrentTime from './CurrentTime';

class Parking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
    };
  }

  searchChange = evt => this.setState({ searchTerm: evt.target.value });

  parking = () => {
    const {
      retrieveSchedule,
      // address,
      cars,
      openParkingDialog,
    } = this.props;
    const { searchTerm } = this.state;

    return (
      <div className="container">
        <CurrentTime retrieveSchedule={retrieveSchedule} />
        <div className="search-container">
          <SearchBar searchChange={this.searchChange} />
        </div>
        <Drivers
          retrieveSchedule={retrieveSchedule}
          cars={cars}
          openParkingDialog={openParkingDialog}
          searchTerm={searchTerm}
        />
      </div>
    );
  };

  render() {
    // const { loggedInPark } = this.props;
    // if (loggedInPark) {
    return this.parking();
    // } else {
    // return <Redirect to="/parkingaccess" />;
    // }
  }
}

export default Parking;



// WEBPACK FOOTER //
// ./src/components/Parking/index.js